import { Message } from './message'

export function Title(props: {
  message: (...args: any) => string
  interpolate: (...args: any) => string
  highlightKey: string
}) {
  return (
    <Message
      message={props.message}
      inputs={{
        [props.highlightKey]: (
          <span class="text-[#2AFD00]">{props.interpolate()}</span>
        ),
      }}
    />
  )
}
